import { render, staticRenderFns } from "./DashboardComp.vue?vue&type=template&id=b3c46526&scoped=true&"
import script from "./DashboardComp.vue?vue&type=script&lang=js&"
export * from "./DashboardComp.vue?vue&type=script&lang=js&"
import style0 from "./DashboardComp.vue?vue&type=style&index=0&id=b3c46526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c46526",
  null
  
)

export default component.exports